"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = validate;
var _validateLoginPassword = require("../repositories/authentication/v1/validate-login-password");
function validate(httpApi, parameters) {
  return (0, _validateLoginPassword.fetchValidateLoginPassword)({
    httpApi,
    parameters,
    config: {
      requestConfig: {
        headers: [['Content-Type', 'application/json']]
      }
    }
  });
}